import { InputPropsBase } from '../interfaces/Inputs';
import { Alignment, FlexDirections, JustifyContents } from '../../layout/models';
import './styles.scss';
import React from 'react';

interface InputContainerProps extends Partial<InputPropsBase<any, any>> {}

export function InputContainer(props: React.PropsWithChildren<InputContainerProps>) {
    return (
        <div
            className={'tsr-input-container' + (props.className ? ' ' + props.className : '')}
            style={{
                gap: props.gap || 30,
                justifyContent: props.justify || JustifyContents.spaceBetween,
                alignContent: props.align || Alignment.center,
                alignItems: props.align || Alignment.center,
                flexDirection: props.direction || FlexDirections.row,
                width: props.width || '100%',
                height: props.height || '100%',
                overflow: props.overflow,
                flex: props.inputContainerLength,
            }}
            aria-describedby={props.areaDescribedBy}
        >
            {props.children}
        </div>
    );
}
